import React, { Component } from "react";
import { connect } from "react-redux";
import { Form as RForm, FormGroup, Label, Input, Button } from "reactstrap";
import * as Helpers from '../../../Utilities/Common';

class Form extends Component{
    constructor(props){
        super(props);
        const { id = "", name = "", short_name = "", address = "", website = "", contact_name = "", contact_email = "", contact_phone = "", comment = "", type = ""} = props.data;
        this.state = { id, name, short_name, address, website, contact_name, contact_email, contact_phone, comment, type };
    }

    setField = (endpoint, option, type = 0) => {
        Helpers.setField(endpoint, option, type, (dataObj) => this.setState((state) => (dataObj)));
    }

    save = (event) => {
        event.preventDefault();
        const { persist, token, permissions, id = '' } = this.props;
        persist(token, this.state, permissions, id);
    }

    render = () => {
        const { name, short_name, address, website, contact_name, contact_email, contact_phone, comment, type } = this.state;
        return (
                <RForm>
                    <FormGroup>
                        <Label>
                            Name*
                        </Label>
                        <Input onChange={(value) => this.setField("name",value)} value={name} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Short Name*
                        </Label>
                        <Input onChange={(value) => this.setField("short_name",value)} value={short_name} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Address*
                        </Label>
                        <Input onChange={(value) => this.setField("address",value)} type="textarea" value={address} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Website*
                        </Label>
                        <Input onChange={(value) => this.setField("website",value)} value={website} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Contact Name*
                        </Label>
                        <Input onChange={(value) => this.setField("contact_name",value)} value={contact_name} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Contact Email*
                        </Label>
                        <Input onChange={(value) => this.setField("contact_email",value)} value={contact_email} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Contact Phone*
                        </Label>
                        <Input onChange={(value) => this.setField("contact_phone",value)} value={contact_phone} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Comments*
                        </Label>
                        <Input onChange={(value) => this.setField("comment",value)} type="textarea" value={comment} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Type*
                        </Label>
                        <Input onChange={(value) => this.setField("type",value)} value={type} />
                    </FormGroup>
                    <FormGroup>
                            <Button block onClick={this.save} color="success" kind="squared">Save</Button>                           
                    </FormGroup>
                </RForm>
        );
    }
}
    const mapStateToProps = (state) => ({
        permissions: state.auth.permissions,
        token: state.auth.token,
    });
    
    export default connect(mapStateToProps)(Form);
    





// WEBPACK FOOTER //
// ./src/Components/App/Companies/Form.js